import {
    CANCEL_OVERRIDE,
    CANCEL_OVERRIDE_SUCCESS,
    CANCEL_OVERRIDE_FAILURE,
    RESET_CANCEL_OVERRIDE,
} from '../actions';

const initialState = {
    loading: false,
    response: null,
    statusCode: '',
    statusMessage: '',
};

const cancelOverrideReducer = (state = initialState, action) => {
    switch (action.type) {
        case CANCEL_OVERRIDE:
            return {
                ...state,
                loading: true,
                response: null,
                statusCode: '',
                statusMessage: '',
            };
        case CANCEL_OVERRIDE_SUCCESS:
            return {
                ...state,
                loading: false,
                response: action.data,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case CANCEL_OVERRIDE_FAILURE:
            return {
                ...state,
                loading: false,
                response: null,
                statusCode: action.data?.statusCode || '',
                statusMessage: action.data?.statusMessage || '',
            };
        case RESET_CANCEL_OVERRIDE:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default cancelOverrideReducer;
